import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { AppUtils } from '../../../helpers';
import { SelectListItemModel } from '../../../models';
import { SupportRequestCreateModel } from '../../../models/supportRequest';
import { MasterDataService, SupportRequestService } from '../../../services';


@Component({
    selector: 'contact-us',
    templateUrl: './contact.us.component.html'
})

export class ContactUsComponent implements OnInit {
    @BlockUI('container-contact') blockUI: NgBlockUI;

    public marketingSources: Array<SelectListItemModel> = new Array<SelectListItemModel>();

    public model: SupportRequestCreateModel = new SupportRequestCreateModel();

    constructor(private vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private masterDataService: MasterDataService,
        private supportRequestService: SupportRequestService) {
        this.toastr.setRootViewContainerRef(this.vcr);
    }

    ngOnInit() {
        this.loadMarketingSources();
    }

    loadMarketingSources() {
        this.blockUI.start();
        this.masterDataService.getMarketingSources()
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    Object.assign(this.marketingSources, data);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    submit(form: NgForm) {
        this.blockUI.start();
        this.supportRequestService.createRequest(this.model)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    form.resetForm();
                    this.model = new SupportRequestCreateModel();
                    this.toastr.success('Your request has been submitted successfully. We will get back to you soon.');
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/miscellaneous/contact/contact.us.component.ts